module.exports = __webpack_public_path__ + "static/media/type-hover-4.825af6fd.jpg";